export default __webpack_public_path__ + "static/media/home-events-conference-img-11.fc99461f.jpg";